import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import classnames from 'classnames/bind';
import noop from 'lodash/noop';
import ToolTip from 'zignal-landscape/lib/ToolTip';

import DropdownIcon from 'zignal-landscape/lib/Icon/DropdownIcon';
import ChevronUpIcon from 'zignal-landscape/lib/Icon/ChevronUpIcon';

const MfeIconWrapper = ({
  styles, icon: SelectedIcon, open, showDot, showChevron = true, disabled, notButton,
  tooltipProps, iconProps={}, onClick = noop, ...rest
}) => {
  // if 'open' is a boolean, display the chevron either up (true) or down (false)
  const ChevronIcon = typeof open === 'boolean' && showChevron && (open ? ChevronUpIcon : DropdownIcon);
  const mergedProps = { style: { fill: 'currentColor' }, ...iconProps };
  const parentClassNames = {
    [styles.MfeIconWrapper]: true,
    [styles.withChevron]: !!ChevronIcon,
    [styles.open]: open,
    [styles.disabled]: disabled || notButton,
    [styles.notButton]: notButton
  };

  const icon = (<div className={classnames(parentClassNames)} onClick={(disabled || notButton) ? noop : onClick} {...rest}>
    <SelectedIcon {...mergedProps} className={styles.icon} />
    { ChevronIcon && <ChevronIcon style={{ fill: 'currentColor' }} className={styles.chevron} /> }
    { showDot && <div className={styles.blueDot} /> }
  </div>);

  return tooltipProps ? <ToolTip {...tooltipProps}>{icon}</ToolTip> : icon;
};

MfeIconWrapper.propTypes = {
  styles: PropTypes.object.isRequired,
  icon: PropTypes.func.isRequired,
  open: PropTypes.bool,
  showDot: PropTypes.bool,
  disabled: PropTypes.bool,
  iconProps: PropTypes.object,
  onClick: PropTypes.func
};

export default themeable(MfeIconWrapper);
